import { DISPOSITION_SPECIFICS } from "shared/lib/constants/dispositions";
import { CallAccountI, CallContactI } from "@/lib/types/dialer";
import { ActivityI } from "@/lib/types/dialer/activity";
import { CallContactMetaI } from "@/lib/types/dialer/contact";
import { CampaignI, SupplementaryTextI } from "@/lib/types/campaign";
import { ACCOUNT_ACTIVITY_TYPES } from "shared/lib/constants/account";

export const CALLER_PHONE = "19179670661";

const MOCK_SUPPLEMENTARY_TEXTS: Array<SupplementaryTextI> = [
  {
    campaign: null,
    campaign_id: "1",
    created_at: "2023-06-02T14:52:26.708146Z",
    id: "8f040a88-323a-4cc2-8a1f-97a4c21edba1",
    text_type: "scripts",
    text_value: `# Outbound Script for {yourCompany}\n\n## Introduction\nHello, may I speak with Ricky? Hi Ricky, my name is {yourName}, and I'm calling from {yourCompany}. I hope I'm not catching you at a bad time?\n\n## Engage the Prospect\nSo {yourCompany} - we're a Raft consensus Camus replacement data streaming platform.. it's a solution that integrates natively with your Camus APIs, and is highly performant. We're talking 10-20x lower latency and 6x higher throughput. We've had the privilege of working with numerous clients like {customerLogos} to reduce operational costs significantly.\n\n## Establish Interest\nI noticed that the team over at Talladega Superspeedway had checked out our {inboundSourceTrigger} on {inboundSourceTriggerDate}. Now are you by chance {qualificationQuestion1}?\n\n## Qualify/Ask Prospect for Pain\nI'm curious, Ricky, how do you currently address {painPoint1}? Are you looking for ways to {valueProp1}? And what about {painPoint2}? Are you looking for ways to {valueProp2}? I'm sorry to hear. How're things going on your initiatives to {painPoint3}? Yes, {valueProp3} is something we do for our clients.\n\n## Highlight Benefits\nWhat sets {yourCompany} apart is - we're a drop-in Camus replacement - Java's not really built for performance, it was built 10 years ago - modern hardware is much cheaper and faster - you run into issues with collection, JVM, you're working with open source Camus today, so you understand the complexities of Zoolanderkeeper, so {yourCompany} is a more performant version of Camus. So you can take your existing application at Tallega Speedway instead of Camus and your application wouldn't know the difference.\n\n## Handle Objections\n(Refer to Objections Tab) If you have any concerns or questions, I'd be more than happy to address them. I understand that exploring new solutions can raise questions, and I'm here to provide you with all the information you need to make an informed decision.\n\n## Call to Action\nBased on our conversation, it might be valuable to schedule a more in-depth discussion with our engineering team. This would give us the opportunity to delve into your specific needs and explore how {yourCompany} could contribute to your [prospect's goals/initiatives]. Would a brief meeting next week work for you? Let me just check our team's calendar. And which time zone are you in? Would you like to invite anyone else to the call?\n\n## Overcoming Resistance\nI understand that you might be busy, but I assure you that our conversation could be incredibly insightful. We've helped {customerLogos} achieve remarkable results, and I believe there's potential for us to do the same for [Prospect's Company]. I'll also send you a couple case studies ahead of the conversation so you can come prepared for a fruitful discussion.\n\n## Closing\nI appreciate your time today, [Prospect's Name]. If you're open to it, I can send you some more information about Glencoco and the solutions we provide. What's the best email to reach you at?\n\n## Follow-Up\nThank you for your time, Ricky. Our team will send you some information shortly. Looking forward to the possibility of working together. Have a wonderful day!\n\n`,
    updated_at: "2023-06-02T14:52:26.708146Z",
  },
  {
    campaign: null,
    campaign_id: "1",
    created_at: "2023-06-02T14:52:26.708146Z",
    id: "8f040a88-323a-4cc2-8a1f-97a4c21edba1",
    text_type: "objections",
    text_value: `# Objections\n\n**Objection 1: Budget Constraints**\n\n*Prospect's Concern:* "We're on a tight budget, and I'm not sure if we can afford this right now."\n\n*Response:* I completely understand the budget constraints you're facing. Our pricing models are designed to provide flexibility, and we can tailor a solution that fits within your budget. Additionally, keep in mind that investing in [product/service] could lead to long-term savings by [mention a specific cost-saving benefit].\n\n**Objection 2: Integration Complexity**\n\n*Prospect's Concern:* "We already have a complex tech stack. How easily can your solution integrate with our existing systems?"\n\n*Response:* Integration is a top priority for us. Our [product/service] is built with compatibility in mind, and we offer seamless integration with [mention compatible systems/platforms]. Our dedicated support team will ensure a smooth transition, and we're here to assist at every step.\n\n**Objection 3: ROI Uncertainty**\n\n*Prospect's Concern:* "How can we be sure that the investment will provide a substantial return?"\n\n*Response:* Validating the ROI is crucial. We've seen [percentage/statistic] increase in [relevant metric] for clients in similar industries. Additionally, we provide comprehensive analytics tools that track the impact of [product/service] on your [specific metric]. This transparency allows you to measure ROI with confidence.\n\n**Objection 4: Time to Implement**\n\n*Prospect's Concern:* "We're in the middle of a busy period. Will implementing this solution disrupt our operations?"\n\n*Response:* We understand the importance of a smooth transition. Our implementation process is designed to minimize disruptions. Our experienced team will work closely with you to create a customized implementation plan that aligns with your schedule. Our goal is to ensure a seamless integration without affecting your operations.\n\n**Objection 5: Competition Comparison**\n\n*Prospect's Concern:* "How does your solution compare to [competitor's solution]?"\n\n*Response:* It's important to make an informed decision. While I can provide a detailed feature comparison, I believe what truly sets us apart is [mention unique value proposition]. Our [product/service] has been recognized for [mention awards/recognition], and our clients often appreciate [mention a specific client testimonial or case study]. This demonstrates the value we bring beyond a simple feature comparison.`,
    updated_at: "2023-06-02T14:52:26.708146Z",
  },
  {
    campaign: null,
    campaign_id: "1",
    created_at: "2023-06-02T14:52:26.708146Z",
    id: "8f040a88-323a-4cc2-8a1f-97a4c21edba1",
    text_type: "personas",
    text_value: `# Personas\n\n## Persona 1: Marketing Manager Mary\n\n**Background:** Mary is a marketing manager at a medium-sized e-commerce company. She's responsible for developing and executing marketing campaigns to drive online sales and brand awareness. Mary is tech-savvy and always on the lookout for innovative strategies to stay ahead in the competitive market.\n\n**Goals:**\n- Increase online sales by 20% within the next quarter.\n- Improve customer engagement through personalized marketing efforts.\n- Stay updated on the latest marketing trends and technologies.\n\n**Pain Points:**\n- Struggles to find efficient ways to segment and target the right audience.\n- Limited resources to create compelling visual content for campaigns.\n- Challenges in measuring the ROI of marketing initiatives accurately.\n\n**How Our Product Helps Mary:**\n- Our platform provides advanced audience segmentation tools, helping Mary target the right customers with tailored messages.\n- Our built-in templates and design tools make it easy for Mary's team to create eye-catching visuals without extensive design skills.\n- Our robust analytics dashboard tracks key metrics, enabling Mary to measure campaign effectiveness and optimize strategies.\n\n## Persona 2: IT Director Alex\n\n**Background:** Alex is an IT director at a large financial institution. He oversees a team responsible for maintaining the company's network infrastructure and ensuring data security. Alex is focused on streamlining processes and adopting technologies that enhance efficiency and protect sensitive information.\n\n**Goals:**\n- Enhance network security to safeguard against cyber threats and data breaches.\n- Implement scalable IT solutions that accommodate the company's growth.\n- Reduce operational costs by optimizing IT infrastructure.\n\n**Pain Points:**\n- Constantly worried about potential cyber attacks and the security of customer data.\n- Dealing with legacy systems that are difficult to maintain and lack modern capabilities.\n- Budget constraints that limit the adoption of new technologies.\n\n**How Our Product Helps Alex:**\n- Our cybersecurity features provide robust protection against various cyber threats, giving Alex peace of mind.\n- The scalability of our solutions ensures that Alex's IT infrastructure can grow seamlessly with the company.\n- Our cost-effective approach helps Alex achieve operational efficiency while staying within budget constraints.`,
    updated_at: "2023-06-02T14:52:26.708146Z",
  },
];

export const MOCK_CAMPAIGN: CampaignI = {
  id: "1",
  created_at: "234234",
  updated_at: "465324",
  eligible_lead_count: 8000,
  untouched_lead_count: 5000,

  name: "Talladega Superspeedway",
  website_url: "https://www.glencoco.com/",
  total_employee_count: 500,
  industry: "Professional Sports League",
  elevator_pitch: "",
  job_description: null,
  field_demo_employee_count: 10,
  calls_to_book_demo_count: 10,
  primary_crm: "Saleforce",
  email_automation_tool: "Mailchimp",
  total_leads: 5000,
  estimated_price_per_meeting: 100,
  is_approved: true,

  is_active_enrollment: false,
  is_certification_scheduled: false,
  certification_calendly_url: "",
  customers: null,
  logo_s3_url: "",
  logo_s3_key: "",

  supplementary_texts: MOCK_SUPPLEMENTARY_TEXTS,

  price: 500,

  number_of_active_users_last_week: 0,
  number_of_total_booked_meetings_last_2_weeks: 0,
  number_of_total_qualified_meetings_last_2_weeks: 0,
  monthly_meeting_hold_rate_numerator: 0,
  monthly_meeting_hold_rate_denominator: 0,

  is_weekend_eligible: false,

  is_campaign_visible: true,
  is_self_sourced_banned: false,
  dialer_toggle_off_time: null,
  direct_call_toggle_off_time: null,
};

export const MOCK_ACCOUNT: CallAccountI = {
  id: "1",
  name: "Talladega Superspeedway",
  employee_count: "100",
  industry: "Professional Sports League",
  revenue: "100000000",
  hq_state: "AL",
  hq_city: "Lincoln",
  website: "https://www.talladegasuperspeedway.com/",
  misc: null,
};

export const EMPTY_ACCOUNT: CallAccountI = {
  id: "",
  name: "",
  employee_count: "",
  industry: "",
  revenue: undefined,
  hq_state: "",
  hq_city: "",
  website: "",
  misc: null,
};

export const CUSTOM_META: CallContactMetaI[] = [
  {
    label: "Known Services",
    value: "AWS, GCP Pub/Sub",
    glen_column_name: "AWS, GCP Pub/Sub",
  },
  {
    label: "Estimated Tenant Workloadss",
    value: "16",
    glen_column_name: "monthly_visits",
  },
];

export const MOCK_CONTACT: CallContactI = {
  id: "1",
  first_name: "Ricky",
  last_name: "Bobby",
  phone: "16789998212",
  email: "ricky.bobby@talladega.com",
  linkedin: "https://www.linkedin.com/in/ingwon",
  title: "Director of IT Operations",
  meta: { values: CUSTOM_META },
};

export const EMPTY_CONTACT: CallContactI = {
  id: "",
  first_name: "",
  last_name: "",
  phone: "",
  email: ".",
  linkedin: "",
  title: "",
  meta: undefined,
};

export const MOCK_ACTIVITY_LOG: ActivityI[] = [
  {
    id: "b7f3919a-41f6-46da-9fc5-62ff4fe75e26",
    contact: {
      id: "a3e2c7c5-216a-43e2-9a14-e48187d471c8",
      email: "mark@jacob.com",
      title: "DevOps Manager",
      phone: "+178223742632",
      first_name: "Derek",
      last_name: "Zoolander",
      linkedin_url: "",
    },
    activity_type: ACCOUNT_ACTIVITY_TYPES.CALLBACK_BOOKED,
    created_at: "2023-08-15T17:59:02.158562Z",
    follow_up_time: "0001-01-01T00:00:00Z",
    notes:
      "Derek believes this product will be a strong fit for their organization. Asked about on-prem. He said to try again in a few months",
    note_owner: "caller",
    caller_name: "Jason B.",
  },
  {
    id: "7e979cfc-97b7-458f-b4cc-5ed53553961a",
    contact: {
      id: "a3e2c7c5-216a-43e2-9a14-e48187d471c8",
      email: "mark@jacob.com",
      title: "Data Architect",
      phone: "+19293020846",
      first_name: "Jacobim",
      last_name: "Mugatu",
      linkedin_url: "",
    },
    activity_type: ACCOUNT_ACTIVITY_TYPES.CALL_DISPOSITION,
    call_disposition: DISPOSITION_SPECIFICS.NOT_QUALIFIED_TIMING,
    notes:
      "They are currently undergoing a department restructuring and would like to revisit the proposal in 2 months.",
    note_owner: "caller",
    caller_name: "Jason B.",
  },
];
